export const blackListApi = ["/api/shop/getShopModule.json","/api/hotel/hotelListAllNew.json","/api/hotel/product/resrvCheck.json","/api/hotel/product/makeOrder.json"]


// WEBPACK FOOTER //
// ./src/utils/blackListApi.js